var _circle, _path, _circle2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8662 32.3179L28.2549 33.5204C29.2907 33.7527 30.3085 33.0788 30.5057 32.0377C30.6909 31.0416 30.0537 30.0782 29.0653 29.8613L21.5893 28.2178L13.7988 33.4777L16.9459 38.1389L19.0399 36.7251L31.5148 39.6152L39.2853 34.3688C40.1429 33.7898 40.369 32.6236 39.79 31.766C39.2098 30.9067 38.0448 30.6823 37.1872 31.2613L32.575 34.3754L29.5976 33.3159",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5788,
    cy: 20.6653,
    r: 6.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7018 17.5739C31.3018 17.5739 31.7728 17.6849 32.1148 17.9069C32.4568 18.1289 32.6878 18.4439 32.8078 18.8519H33.4828V19.3379H32.8978C32.9038 19.3919 32.9068 19.4459 32.9068 19.4999C32.9128 19.5539 32.9158 19.6079 32.9158 19.6619C32.9158 19.7399 32.9128 19.8209 32.9068 19.9049C32.9008 19.9829 32.8918 20.0609 32.8798 20.1389H33.4828V20.6249H32.7538C32.6638 20.8709 32.5258 21.0899 32.3398 21.2819C32.1538 21.4739 31.9138 21.6269 31.6198 21.7409C31.3258 21.8489 30.9688 21.9029 30.5488 21.9029H30.0448V23.9999H29.2978V20.6249H28.5148V20.1389H29.2978V19.3379H28.5148V18.8519H29.2978V17.5739H30.7018ZM31.9168 20.6249H30.0448V21.2369H30.5038C30.8578 21.2369 31.1518 21.1889 31.3858 21.0929C31.6198 20.9969 31.7968 20.8409 31.9168 20.6249ZM32.0968 19.3379H30.0448V20.1389H32.0878C32.0998 20.0729 32.1088 20.0039 32.1148 19.9319C32.1208 19.8539 32.1238 19.7759 32.1238 19.6979C32.1238 19.6319 32.1208 19.5719 32.1148 19.5179C32.1148 19.4579 32.1088 19.3979 32.0968 19.3379ZM30.6748 18.2399H30.0448V18.8519H31.9438C31.8358 18.6479 31.6768 18.4949 31.4668 18.3929C31.2568 18.2909 30.9928 18.2399 30.6748 18.2399Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/requestIcon.6a29447317444f23873529cd74287c12.svg";
export { ForwardRef as ReactComponent };